import axios, { AxiosError } from 'axios';
import { Account } from '../models/account';

const instance = axios.create({
	baseURL: import.meta.env.VITE_API_URL,
	headers: {
		'Content-Type': 'application/json',
		apiKey: import.meta.env.VITE_API_KEY,
	},
	withCredentials: true,
});

instance.interceptors.request.use(config => {
	config.headers['ngrok-skip-browser-warning'] = 'true';
	return config;
});

instance.interceptors.response.use(
	res => {
		return res;
	},
	async (err: AxiosError) => {
		const originalConfig = err.config;
		if (!originalConfig || !err.response) {
			return Promise.reject(err);
		}
		// Access Token was expired
		if (err.response.status === 401 && !originalConfig._retry) {
			originalConfig._retry = true;

			try {
				await instance.post<Account>(`/api/auth/refresh-token`, {});
				return instance(originalConfig);
			} catch (_error) {
				return Promise.reject(err);
			}
		}

		return Promise.reject(err);
	},
);

export default instance;
